import { render, staticRenderFns } from "./Weeks.vue?vue&type=template&id=2c8322be&scoped=true&"
import script from "./Weeks.vue?vue&type=script&lang=js&"
export * from "./Weeks.vue?vue&type=script&lang=js&"
import style0 from "./Weeks.vue?vue&type=style&index=0&id=2c8322be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8322be",
  null
  
)

export default component.exports